var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-checkbox flex"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"click":_vm.change}})])}
var staticRenderFns = []

export { render, staticRenderFns }